import type { FC } from 'react';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import type { Props } from './DatePickerPopup';
import { formatDisplayDate } from './dateHelpers';

const DateControls = lazy(
  () =>
    import(
      /* webpackChunkName: "datepicker_ng" */
      './DatePickerPopup'
    )
);

const DateControlsLoadable: FC<Props> = props => {
  const { t, i18n } = useTranslation();
  const isMounted = useIsMounted();
  const label = props.date
    ? formatDisplayDate(props.date, i18n.language)
    : t('subnavigation.button.datepicker');

  const Loader = <span className={props.className}>{label}</span>;

  if (!isMounted) {
    return Loader;
  }

  return (
    <Suspense fallback={Loader}>
      <DateControls {...props} />
    </Suspense>
  );
};
DateControlsLoadable.displayName = 'DateControlsLoadable';

export default DateControlsLoadable;
